import React from 'react'
import {Link} from '../../link'
import {SlotComponent} from '../../../types/ui'
import {Box, Text} from '../../../vanilla'
import {CmsImage} from '../cms-image'
import {QuickLinkCmsContent} from '../../../types/cms'
import {imageContainer, quickLinkItem, quickLinkLabel} from './styles.css'
import {useSelectPromotionTracking} from '../../../analytics/promotion-tracking'

interface QuickLinkProps {
  promotion: object
  elementRef: (el: HTMLAnchorElement | null) => void
  quickLinkKey: string
}

export const QuickLink: SlotComponent<QuickLinkCmsContent, QuickLinkProps> = ({
  content,
  promotion,
  elementRef,
  quickLinkKey
}) => {
  const {displayName, image, imageLink} = content
  const sendSelectPromotion = useSelectPromotionTracking()

  return (
    <Link
      to={imageLink}
      className={quickLinkItem}
      onClickCapture={() => sendSelectPromotion(promotion)}
      disableExternalLinkIcon
      ref={elementRef}
      data-quicklink-key={quickLinkKey}
      data-test-selector="quick-link"
    >
      <Box className={imageContainer}>
        {image?.images && <CmsImage images={image.images} width="full" height="full" />}
      </Box>
      <Text className={quickLinkLabel}>{displayName}</Text>
    </Link>
  )
}
